import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getBundlesData = {
  name: "getBundlesData" as const,
  input: z.object({
    teamId: z.string(),
    pageSize: z.number(),
    pageContinue: z.number(),
  }),
  output: z.object({
    bundles: z.array(
      z.object({
        parentProductName: z.string(),
        parentProductImageSrc: z.string(),
        parentVariantId: z.string(),
        parts: z.array(
          z.object({
            variantId: z.string(),
            returnable: z.boolean(),
            imageSrc: z.string(),
            productName: z.string(),
          }),
        ),
        allowedTypes: z.array(createEnum(ReturnTypeEnum)),
      }),
    ),
    enabledReturnTypes: z.array(createEnum(ReturnTypeEnum)),
    pageNext: z.number().nullish(),
  }),
};
